<template>
<div  @click.stop >
    <van-dialog
        class="dialog_box-wrap"
        v-model="showDialog"
        :title="title"
        :confirmButtonText="lan.confirm"
        :cancelButtonText="lan.cancel"
        cancelButtonColor="#333333"
        confirmButtonColor="#333333"
        show-cancel-button
        :before-close="closeDialog">
        <div class="imgCodeBox">
            <div class="imgCode">
                <input
                    class="imgCode-input"
                    :placeholder="lan.imgCodeInput"
                    v-model.trim="imageCode"
                >
                <img class="imgCodeUrl global_pointer" @click="getImgCode" :src="imgCodeUrl"  alt=""/>
            </div>
            <div class="imgCodeTip global_pointer"  @click="getImgCode" >
                {{lan.codeTip}}
            </div>
        </div>
    </van-dialog>
    <safeCheckout validateId="captcha" ref="safeCheckoutCode" @getSafeValidate="getSafeValidate" />
</div>
</template>

<script>
import { Dialog } from 'vant';
import safeCheckout from '@/components/safeCheckout';

import api from '@/api/api_list';
export default {
    components: {
        [Dialog.Component.name]: Dialog.Component,
        safeCheckout,
    },
    props: {
        mobile: String,
    },
    data() {
        return {
            lan:  {
                phonePlaceholder: 'Moblie Phone Number',
                codePlaceholder: 'Verification code',
                getCode: 'Get code',
                gettingCode: 'Getting',
                reGetCode: 'Retry',
                login: 'Log In or Register',
                loginTopic: 'By signing up you agree to the',
                loginTopicPrivacy: 'Privacy Policy',
                loginTopicAnd: 'and',
                loginTopicRegister: 'Term of Use ',
                friendInvite: 'Invitation code (optional)',
                emailPlaceholder: 'Enter your email',
                setPassword: 'Password (letters + nums + chars)',
                agreeText: 'Please read and check the registration agreement',
                passwordErr: 'Password does not meet requirements',
                phoneError: 'Please enter the correct mobile phone number',
                imgCodeTip: 'Please enter the characters displayed in the image',
                imgCodeAnswer: 'Please enter the answer to the equation',
                codeTip: 'Unclear? Change another',
                imgCodeInput: 'Please enter',
                confirm: 'Confirm',
                cancel: 'Cancel',
                slideTip: 'Drag the pieces atop one another',
                loginInfo: '',
                logout: 'Log Out'
            },
            imgCodeUrl: '',
            imageCode: '',
            type: 2,
            showDialog: false,
            IsCheckout: 0,
            safeValidate: '',
        }
    },
    computed: {
        title() {
            return this.type === 1 ? this.lan.imgCodeTip : this.lan.imgCodeAnswer;
        }
    },
    mounted() {
        // this.getImgCode()
    },
    methods: {
        closeDialog(action, done) {
            if (action === 'confirm') {
                if (!this.imageCode) {
                    this.$toast(this.title)
                    done(false)
                } else {
                    this.$emit('getInfoCode', {
                        imageCode: this.imageCode,
                    })
                    done(true)
                }
            } else {
                this.$emit('cancel')
                // this.$refs.safeCheckoutCode.loginSafeShow();
                done(true)
            }
        },
        getSafeValidate(validate) {
            console.log('validate' + validate);
            this.$emit('getInfoCode', {
                validate,
            })
            setTimeout(() => {
                this.$refs.safeCheckoutCode.refresh()
            }, 2000)
        },
        
        imgCodeCheckout(result) {
            this.imgCodeUrl = `data:image/png;base64,${result.base64Image}`
            this.showDialog = true
        },

        // 获取图片验证码
        async getImgCode() {
            console.log('this.mobile', this.mobile)
            const { code, result } = await api.get_img_code({ mobile: this.mobile });
            if (code == 0) {
                this.type = result.type;
                if (this.type == 0) { // 不需要验证
                    this.$emit('getInfoCode');
                }
                if (this.type == 1 || this.type == 2) { // 图形验证码
                    this.imgCodeCheckout(result);
                }
                if (this.type == 3) { //滑块验证码
                    this.$refs.safeCheckoutCode.loginSafeShow();
                }

            }
        },
    },
}
</script>

<style lang="less" scoped>
.dialog_box-wrap{
    width:  360px;
}
/deep/.van-dialog__header{
    text-align: center;
    font-size: 15px;
}
.imgCodeBox{
    display: flex;
    padding:0 10px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    height: 40px;
    margin: 15px 0;
    .imgCode{
        display: flex;
        width: 100%;
        .imgCode-input{
            background-color: #f7f8fa;
            border-radius: 3px;
            width: 60%;
            height: 30px;
            box-sizing: border-box;
            padding: 0 8px;
        }
        .imgCodeUrl{
            display: block;
            flex: 1;
            margin-left: 5px;
            z-index: 1000;
            height: 30px;
        }
    }
    .imgCodeTip{
        text-align: right;
        color: #888888;
        font-size: 12px;
        white-space: nowrap;
        padding-top: 5px;
    }
}
</style>
